export const MATERIAL_MECHANICAL_PROPERTY_SCALES = Object.freeze([
  { value: 'MPa_Rm', label: 'MPa (Rm)' },
  { value: 'HBW', label: 'HBW' },
  { value: 'HV', label: 'HV' },
  { value: 'HRC', label: 'HRC' },
  { value: 'HRB', label: 'HRB' },
  { value: 'HRA', label: 'HRA' },
]);

const ALLOWED_SCALE_IDS = MATERIAL_MECHANICAL_PROPERTY_SCALES.map(({ value }) => value);

export function resolveMaterialMechanicalProperty(material = {}) {
  if (material.mechanicalProperty !== undefined) {
    try {
      return {
        ...normalizeMaterialMechanicalProperty(material.mechanicalProperty),
        source: 'mechanicalProperty',
      };
    } catch {
      // Invalid new data must not hide a valid legacy MPa value.
    }
  }
  if (material.tensileStrength !== undefined && material.tensileStrength !== null) {
    try {
      return {
        value: normalizeMaterialMechanicalProperty({
          value: material.tensileStrength,
          scale: 'MPa_Rm',
        }).value,
        scale: 'MPa_Rm',
        source: 'legacy_tensileStrength',
      };
    } catch {
      return null;
    }
  }
  return null;
}

export function normalizeMaterialMechanicalProperty(mechanicalProperty) {
  if (!ALLOWED_SCALE_IDS.includes(mechanicalProperty?.scale)) {
    throw new Error('Select a supported mechanical-property scale.');
  }
  if (typeof mechanicalProperty.value === 'string') {
    const trimmedValue = mechanicalProperty.value.trim();
    if (!trimmedValue) throw new Error('Enter a mechanical strength or hardness value.');
    if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(trimmedValue)) {
      throw new Error('Mechanical strength or hardness must be a positive finite number.');
    }
  }
  const value = Number(mechanicalProperty.value);
  if (!Number.isFinite(value) || value <= 0) {
    throw new Error('Mechanical strength or hardness must be a positive finite number.');
  }
  return { value, scale: mechanicalProperty.scale };
}

export function prepareMaterialFormPayload(materialData) {
  const mechanicalProperty = normalizeMaterialMechanicalProperty(materialData.mechanicalProperty);
  const payload = { ...materialData, mechanicalProperty };
  if (mechanicalProperty.scale === 'MPa_Rm') {
    payload.tensileStrength = mechanicalProperty.value;
  } else {
    // Hardness is authoritative. Never persist an inferred MPa equivalent.
    delete payload.tensileStrength;
  }
  return payload;
}

export function getMaterialMechanicalPropertyPresentation(material) {
  const property = resolveMaterialMechanicalProperty(material);
  if (!property) return null;
  const isTensileStrength = property.scale === 'MPa_Rm';
  return {
    ...property,
    label: isTensileStrength ? 'Tensile Strength' : 'Hardness',
    unit: isTensileStrength ? 'MPa' : property.scale,
  };
}
